// Kenar menüsünün (components/layout/Sidebar.js) çalışma anı görünürlük koşulları; aynı uçlar, aynı varsayılanlar.
// Yalnız İçeri Al çalışma alanı açıkken (enabled) istek atar.
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useNavVisibility(enabled) {
  const [vis, setVis] = useState({ support: true, hepsiJet: false, accountingProvider: "" });
  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    const set = (patch) => { if (!cancelled) setVis((v) => ({ ...v, ...patch })); };
    (async () => {
      try {
        let res;
        try { res = await api.get("/integration-providers"); } catch (e) { res = await api.get("/integrations/providers"); }
        const rows = Array.isArray(res?.items) ? res.items : [];
        set({ support: rows.some((x) => String(x?.key || "").toLowerCase() === "support_center") });
      } catch (e) { set({ support: true }); }
    })();
    (async () => {
      try {
        const [cfg, intg] = await Promise.all([api.get("/hepsijet/config").catch(() => null), api.get("/integrations").catch(() => [])]);
        const rows = Array.isArray(intg) ? intg : [];
        const has = rows.some((r) => String(r?.provider || "").trim().toLowerCase() === "hepsijet" && String(r?.status || "").trim().toLowerCase() !== "deleted");
        set({ hepsiJet: Boolean(cfg?.configured) || has });
      } catch (e) { set({ hepsiJet: false }); }
    })();
    (async () => {
      try {
        const cfg = await api.get("/settings/accounting").catch(() => null);
        const p = String(cfg?.provider || "").trim().toLowerCase();
        set({ accountingProvider: p === "parasut" || p === "bizimhesap" ? p : "" });
      } catch (e) { set({ accountingProvider: "" }); }
    })();
    return () => { cancelled = true; };
  }, [enabled]);
  return vis;
}
